import images from "@assets/images";
import { useNavigation } from "@react-navigation/native";
import { useDimensionContext } from "@src/DimensionProvider";
import { useAppSelector } from "@src/ducks/ducksHook";
import { useLobbyService } from "@src/ducks/hooks";
import { selectedUserCoins } from "@src/ducks/slices/user.slice";
import { ImageButton02, ImageButton04 } from "components/button";
import numeral from "numeral";
import React, { useMemo } from "react";
import { Image, Text, View } from "react-native";
import Animated, { Extrapolation, interpolate, useAnimatedStyle } from "react-native-reanimated";
import useOrientationListener from "utils/orientation-helper";
import styles from "./styles.css";

function Items(props: any) {
  const navigation = useNavigation<any>();
  const { onChangeScreen } = useLobbyService();
  const orientation = useOrientationListener();
  const {translateX, translateY, isOpen} = props;
  const balance  = useAppSelector(selectedUserCoins);
  const { baseWidth, baseHeight } = useDimensionContext();

  const { screenWidth, screenHeight, circleSize } = useMemo(() => {
    const screenWidth = orientation === "LANDSCAPE" ? baseWidth * 0.1208 : baseWidth * 0.34;
    const screenHeight = screenWidth * 1.25;

    return {
      screenWidth: screenWidth, 
      screenHeight: screenHeight,
      circleSize: screenWidth * 0.3,
    };
  },[baseWidth, baseHeight, orientation]);

  const animatedContainerStyle = useAnimatedStyle(() => {

    return {
      alignItems: "center",
      position: "absolute", 
      width: screenWidth, 
      height: screenHeight,
      top: "2%",
      left: -(screenWidth / 2) + circleSize / 2,
      transform: [
        { translateX: translateX.value },
        { translateY: translateY.value },
      ],
    };
  }, [screenWidth, screenHeight, circleSize]);

  const animatedStyle = useAnimatedStyle(() => {
    const width = interpolate(
      isOpen.value,
      [0, 1],
      [0, screenWidth],
      Extrapolation.CLAMP
    );
    const height = interpolate(
      isOpen.value,
      [0, 1],
      [0, screenHeight],
      Extrapolation.CLAMP
    );
    return {
      overflow: "hidden",
      width: width, 
      height: height,
    };
  }, [screenWidth, screenHeight]);

  const onPress = (name: string) => {
    switch (name) {
    case "Home":
      onChangeScreen({ screen: "main" });
      navigation.navigate("Home");
      break;
    case "Settings":
      navigation.navigate("Settings");
      break;
    case "Shop":
      navigation.navigate("BuyShop");
      break;
    }
  };

  return (
    <Animated.View pointerEvents='box-none' style={animatedContainerStyle} >
      <Animated.View pointerEvents='box-none' style={animatedStyle} >
        <Image style={{width: "100%", height: "100%", position: "absolute", transform: [{rotate: "180deg"}]}} source={{uri: images["dropdown-bg"]}} resizeMode="stretch"/>
        <View pointerEvents='auto' style={[ styles.v_container, { gap: screenHeight * 0.037 }]}>
          <View style={{height: "18%"}} />
          <View style={styles.v_row}>
            <ImageButton04 onPress={() => onPress("Home")}
              source={{uri: images["home-button"]}} 
              style={{width: "45%", height: "100%"}} />
            <ImageButton04 onPress={() => onPress("Settings")}
              source={{uri: images["settings-button"]}} 
              style={{width: "45%", height: "100%"}} />
          </View>
          <ImageButton04 onPress={() => onPress("Shop")}
            source={{uri: images["shop-button"]}} 
            style={{width: "80%", height: "20%"}} />
          <ImageButton02 disabled
            style={{width: "80%", height: "20%"}} >
            <Image style={{width: "100%", height: "100%"}} source={{uri: images["palms-gold-button"]}} resizeMode="stretch"/>
            <Text selectable={false} style={[styles.t_palms_gold, { fontSize: screenWidth * 0.1}]}>{numeral(balance["GOLD"]).format("0,000.00")}</Text>
          </ImageButton02>
        </View>
      </Animated.View>
    </Animated.View>
   
  );
}

export default Items;
